import { render, staticRenderFns } from "./PanelPage.vue?vue&type=template&id=21fb36e6&scoped=true&"
import script from "./PanelPage.vue?vue&type=script&lang=js&"
export * from "./PanelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb36e6",
  null
  
)

export default component.exports